import React from "react";
import { GiSmartphone } from "react-icons/gi";
import { BsEnvelope } from "react-icons/bs";
import { MdOutlineLocationOn } from "react-icons/md";
import Social from "../UIElements/Social";

const ContactData = () => {
  return (
    <>
      <div className="contact-data">
        <div className="contact-title">
          <h3 className="contact-heading">reach us</h3>
        </div>
        <div className="contact-content">
          <p className="contact-para">
            Massa inceptos porta a pretium a consectetur phasellus suspendisse
            ridiculus ipsum senectus lobortis euismod ut blandit sodales justo
            ligula ullamcorper egestas nulla. Fames parturient vulputate
            ullamcorper faucibus urna at nunc ridiculus quis.
          </p>
        </div>
        <div className="contact-grid">
          <div className="grid-content 1">
            <div className="grid-icon">
              <GiSmartphone className="contact-grid-icon" />
            </div>
            <div className="grid-bio">
              <p>Phone: +91-89205-11882</p>
            </div>
          </div>

          <div className="grid-content 1">
            <div className="grid-icon">
              <BsEnvelope className="contact-grid-icon" />
            </div>
            <div className="grid-bio">
              <p>Email: rohit892051182@gmail.com</p>
            </div>
          </div>
          <div className="grid-content 1">
            <div className="grid-icon">
              <MdOutlineLocationOn className="contact-grid-icon" />
            </div>
            <div className="grid-bio">
              <p>Location: Subhash Nagar, New Delhi INDIA</p>
            </div>
          </div>
        </div>
        <div className="contact-social">
          <Social />
        </div>
      </div>
    </>
  );
};

export default ContactData;

// var timeinc = 2000;

// for(let i = 0; i < 5; i++){
//   setTimeout(()=>{
//     document.getElementsByClassName("_acan")[1].click()
//   }, timeinc)
//   timeinc += 2000

//   setTimeout(()=>{
//      document.getElementsByClassName("_acan")[1].click()
//   }, timeinc)
//   timeinc += 2000

//   setTimeout(()=>{
//     document.getElementsByClassName("_a9-- _a9-_")[0].click();
//   }, timeinc)
//   timeinc += 2000

// }
